import axios from 'axios';

// Details for Storefront API.
const storefrontAccessToken = {
    dev: 'd0b08c014ba4e9c04e39c2a3718c6e18',
    prod: 'd32ae2953ad995ea42e52a0bd2fe6131'
};

function getAccessToken() {
    return Shopify.shop == 'astro-sandbox-titan-22.myshopify.com' ? storefrontAccessToken.dev : storefrontAccessToken.prod;
}

export const storefrontRequestConfig = {
    headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': getAccessToken()
    }
};

// XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
export const xhrRequestConfig = {
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

export function fetchStorefrontNodes(recordQuery, ids, previousNodes=[]) {
    const batchIds = ids.splice(0, 250);
    const remainingIds = ids.slice(250);
    const query = `{
    nodes(ids: [${batchIds}]) {
        ${recordQuery}
    }
    }`;

    return axios
    .post(`https://${Shopify.shop}/api/graphql`, query, storefrontRequestConfig)
    .then(async ({ data }) => {
        if (data.errors) {
        console.log('Error fetching Storefront records:', data.errors);
        return previousNodes;
        }

        const nodes = [...previousNodes, ...data.data.nodes];

        if (remainingIds.length) {
        return fetchStorefrontNodes(recordQuery, remainingIds, nodes);
        } else {
        return nodes;
        }

    })
    .catch((error) => {
        console.log(error);
        return previousNodes;
    });
}
